import { fetchFromAPI } from 'utils/api';

export const updateGenetic = (id, resource = {}) => fetchFromAPI(`/admin/genetics/${id}`, {
  method: 'PUT',
  body: JSON.stringify({ resource }),
});

export const fetchGenetic = (id) => fetchFromAPI(`/admin/genetics/${id}`);
